export default __webpack_public_path__ + "static/spotify-2637e93ac0799a86e00f91e3af2e0512.png";